import { render, staticRenderFns } from "./RecommendBest.vue?vue&type=template&id=78854a5e&"
import script from "./RecommendBest.vue?vue&type=script&lang=js&"
export * from "./RecommendBest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78854a5e', component.options)
    } else {
      api.reload('78854a5e', component.options)
    }
    module.hot.accept("./RecommendBest.vue?vue&type=template&id=78854a5e&", function () {
      api.rerender('78854a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RecommendBest.vue"
export default component.exports